import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// The provider opened the youth on its placement list: it stops being flagged as new
export const viewOtoIndividualEnrollment = (input: { enrollmentId: number }) => {
  const { enrollmentId } = input
  return restApiClient
    .url(constructApiUrl(API.enrollments.viewOtoIndividualEnrollment.url, { enrollmentId }))
    .post()
}
